import React, { useState } from 'react'
import "./imageUploadBtn.css"
import Upload from "../../Icons/Upload";
import RedCross from "../../Icons/RedCross";
import Svgattach from '../../Icons/SectionIcons/attach'
import { useTranslation} from "react-i18next";
import { uploadImageAPI } from '../../components/IFormDesignerLayout/RequestLogic';
import { GetState, GetStateFromData } from '../../components/CustomHooks/CustomHooks';
import { updatedComponentInFormStates } from '../../components/IFormDesignerLayout/IFormDesignerLogic';

function ImageUploadBtn(props) {
    const {t}=useTranslation();
    const {handleImageUpload,iconName,uploadindex,showIcon, acceptType = "image"}=props;
    const contexts = GetStateFromData(props.containerId);
    const {controlSelected, templateLoaded} = GetState("controlSelected", "templateLoaded");

const { activePage, activeSubForm, microFrontendData, showAlertConfirmNotifications, activeApplication,builderMode } = contexts.contexts;

const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";

    const updateImageProperty = (imageDetails) => {
      props.selectedControl.style.imageStyle["width"] = imageDetails?.width;
      props.selectedControl.style.imageStyle["height"] = imageDetails?.height;
      updatedComponentInFormStates(props?.selectedControl?.id, props?.selectedControl);
    }
    async function uploadImage(event,action){
        if (action === "add") {
          let invalid = false;
          const imageObject = event.target.files[0];

          if (imageObject && props?.selectedControl?.elem_type === "image") {
            const reader = new FileReader();
            const columnHeight = document.getElementById(props?.selectedControl?.id)?.closest(`[elem_type=column]`)?.getBoundingClientRect()?.height
            const columnWidth = document.getElementById(props?.selectedControl?.id)?.closest(`[elem_type=column]`)?.getBoundingClientRect()?.width
      
            reader.onload = (event) => {
              const img = new Image();
              img.src = event.target.result;
      
              img.onload = () => {
                let imageDetails = {
                  width: img.width > columnWidth ? Math.floor(columnWidth) : Math.floor(img.width),
                  height: img.height > columnHeight ? Math.floor(columnHeight) : Math.floor(img.height),
                }
                updateImageProperty(imageDetails)
              };
            };
            reader.readAsDataURL(imageObject);
          }

          if (!imageObject.type.includes(acceptType)) {
            invalid = true;
            showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: "INVALID_FILE_TYPE",
            });

            // window.setTimeout(() => {
            //   showAlertConfirmNotifications({
            //     open: false,
            //     showConfirm: "showNotification",
            //     alertType: "error",
            //     alertContentKey: "INVALID_FILE_TYPE",
            //   });
            // }, 1000);
          }
          let uploadType = imageObject.type;
          let sizeValue = Number(window.psh_configs.image_control_max_size + "000")
          if (imageObject.size > sizeValue) {
            showAlertConfirmNotifications({
              'open':true,
              'showConfirm':'showNotification',
              'alertType':'error',
              'alertContentKey':`${imageObject.name} ${t("won't be uploaded as the file size should be less than or equals to")} ${window.psh_configs.image_control_max_size}KB.`
            });
           
          } else {
            if (!invalid) {
              try {
                const isPortal = builderMode === "application";

                if((isPortal || activePage || activeSubForm || templateLoaded) && !(props.shouldUploadImg || controlSelected?.isWizardHeader)) {
                  const jsonToSend = {
                    imageObject,
                    applicationName:
                      microFrontendData?.processName ||
                      microFrontendData?.applicationName ||
                      microFrontendData?.processDefId ||
                      "",
                    formName:
                      microFrontendData?.taskId ||
                      microFrontendData?.formName ||
                      activePage?.formName ||
                      activeSubForm?.fragmentName ||
                      microFrontendData?.formId ||
                      microFrontendData?.formDefId ||
                      "",
                    pageName : activePage ? activePage.formName : null,
                    subPageName : activeSubForm ? activeSubForm.fragmentName : null,
                  };
  
                  const response = await uploadImageAPI(jsonToSend);
                  handleImageUpload(imageObject.name, response.data, uploadindex,uploadType.includes("image"));
                } else {
                  const imageBase64 = await convertBase64(imageObject);
                  handleImageUpload(imageObject.name, imageBase64, uploadindex,uploadType.includes("image"));
                }
                
            } catch (error) {
                showAlertConfirmNotifications({
                    open: true,
                    showConfirm: "showNotification",
                    alertType: "error",
                    alertContentKey: error || "Failed to upload Image.",
                });
            }
            }
          }
          event.target.value = '';
        } else if (action === "remove") {
          if(props?.selectedControl && props?.selectedControl?.elem_type === "image"){
            let imageDetails = {
              width: "180",
              height: "100",
            }
            updateImageProperty(imageDetails)
          }
          handleImageUpload("", "", uploadindex);
        }
    }

    const convertBase64 =(file) => {
        return new Promise((resolve,reject) => {
          const fileReader=new FileReader();
          fileReader.readAsDataURL(file);
          fileReader.onload = () => {
            resolve(fileReader.result);
          };
  
          fileReader.onerror =(error) => {
            reject(error);
          };
        });
      };

    return (
        <>
        { iconName===undefined || iconName===""
        ?
        props.type && props.type==="1"?
        <label  aria-label={"Upload Image"} className="afb_imageUploadBtn">
          <Upload/> Icon
          <input type="file" 
          aria-label={"Upload Image"}
          accept="image/svg+xml"
          onChange={(e)=>uploadImage(e,"add")} />
        </label>
        :
        <div className="afb_fileUploadParent" style={{...props.style, ...props.parentStyle, borderRadius:props?.containerName === "tab"?'2px':''}}>
            <span tabIndex={0} className="afb_text" style={{color:"black",padding:translationStyles1? "0 8px 0 0" :null, boxSizing:"unset", fontWeight: 400, whiteSpace:'nowrap', minWidth:props?.containerName === "tab" ? '96%':'100%'}}>{props.placeholder || t("Browse from system")} 
            <span className="afb_icon" style={{...props.style, left:translationStyles1?"-1px":null, borderTopRightRadius:props?.containerName === "tab"?'2px':'',borderBottomRightRadius:props?.containerName === "tab"?'2px':'', height:props?.height?props.height:null}} > <Svgattach color={"#606060"} /> </span>  </span>
            <input 
            title={t("No File Chosen")}
            className="fileUpload" 
            aria-label={"File Upload"}
            type="file" 
            tabIndex={-1}
            accept="image/jpeg, image/png, image/svg+xml"
            uploadindex={uploadindex} 
            onChange={(e)=>uploadImage(e,"add")}
            />
        </div>
        : 
        <div className="afb_imageUploadBtn2" style={props.style2} >
        <span className="afb_overflowedText">
          {iconName} 
        </span>
        <span onClick={(e)=>uploadImage(e,"remove")}>
        <RedCross className={showIcon==="true"? "afb_deleteIcon": ""} />
        </span>
        
        </div>
        }
        </>
    )
}

export default ImageUploadBtn